import { render, staticRenderFns } from "./HeaderMarketBar.vue?vue&type=template&id=e2bf764a"
import script from "./HeaderMarketBar.vue?vue&type=script&lang=js"
export * from "./HeaderMarketBar.vue?vue&type=script&lang=js"
import style0 from "./HeaderMarketBar.vue?vue&type=style&index=0&id=e2bf764a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports